// Module
var code = "<div class=\"setup-panel__item setup-panel__item--position-right\">\n  <div class=\"setup-connectivity\" v-bind:class=\"networkStatus\"></div>\n  <div class=\"setup-connectivity\" v-bind:class=\"serverStatus\"></div>\n  <clock-root v-bind:delay=\"delay\" class=\"setup-clock\"></clock-root>\n</div>\n";
// Exports
export default code;